import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const FavoriteButtonComponent = ({ value, onFavoriteButton }) => {
  const isFollowed = value.beneficiaryDTO?.followed || value.followed

  return (
    <Grid>
      <Row center="xs">
        <Col xs={12}>
          <Button
            circle
            small
            outlined
            onClick={onFavoriteButton}
          >
            <FontAwesomeIcon
              size="lg"
              icon="star"
              css={(styles.icon, { color: isFollowed ? 'green' : '#ffffff' })}
            />
            <Text size={11}>Favorite</Text>
          </Button>
        </Col>
      </Row>
    </Grid>
  )
}

FavoriteButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onFavoriteButton: PropTypes.func.isRequired,
}

export default FavoriteButtonComponent
